import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { SaveForm, SaveFormSchema } from 'types/pages/audience-builder/shared/save/form';

export const useCreateForm = () => {
  const methods = useForm<SaveForm>({
    mode: 'onChange',
    resolver: zodResolver(SaveFormSchema),
    reValidateMode: 'onChange',
  });

  return methods;
};
